import { PET_HOSTING_SERVICE_ID } from '~/common/constants/app';

export const SERVICE_TYPES_SUPPORTING_AREA_10 = ['Dog Boarding'];
export const SERVICE_TYPES_IDS_SUPPORTING_AREA_10 = [PET_HOSTING_SERVICE_ID];

export const SCRIPT_ELEMENT_ID = 'a10_script';
export const PAN_ELEMENT_ID = 'a10_pan';
export const AREA_10_CMAX_SCRIPT_URL = '//limitless.cmax.ai/madpaws.com.au/pan/js';
